import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import OfferFilters from '../../HotelOffers/OfferFilters';
import { onSearchControlsSubmit } from '../utils';

import PrimaryNavigation from './PrimaryNavigation';

import type { Configs } from '@shared/types/configs';
import type { UserContext } from '@shared/types/user-context';
import type { Stay, Nullable } from '@shared/types/utils';
import type { Destination } from '@shared/ui/types';
import type { NavigationItems } from '@shared/utils-frontend/navigation-service';

import STYLES from './Navigation.module.scss';

import SearchBar from '@shared/hotels-search-controls/SearchBar';
import { withConfiguration } from '@shared/utils-frontend/contexts/ConfigurationContext';
import { withUserContext } from '@shared/utils-frontend/contexts/UserContext';

const cls = cssModules(STYLES);

type Props = {
  applyFilters: () => void;
  needFixed: boolean;
  refCallback: Function;
  showFilters: boolean;
};

type NavigationProps = Props & {
  items: NavigationItems;
  onClick: (anchorName: string, id: string) => void;
  stay: Stay;
  priceIndex: number;
  selected: Nullable<string>;
  height?: number;
  userContext: UserContext;
  configs: Configs;
  destination: Destination;
};

const Navigation = ({
  applyFilters,
  configs: { showStickySearchControlsOnHotelDetailsSEO },
  destination,
  needFixed,
  refCallback,
  showFilters,
  stay,
  userContext: { enableSEOVariantHotelsDetailsPage },
  ...props
}: NavigationProps) => {
  const seoVariantConfig =
    enableSEOVariantHotelsDetailsPage &&
    showStickySearchControlsOnHotelDetailsSEO;

  return (
    <div
      data-test-id="navigation-bar"
      className={cls('Navigation', needFixed ? 'Navigation__fixed' : null)}
      ref={(ref) => refCallback(ref)}
    >
      {needFixed && seoVariantConfig && (
        <div className={cls('Navigation__searchBarWrapper')}>
          <SearchBar
            className={cls('Navigation__searchBar')}
            stay={stay}
            isMobile={false}
            arrangeInline
            onSearchControlsSubmit={onSearchControlsSubmit}
            destination={destination}
          />
        </div>
      )}
      <div
        className={cls('Navigation', needFixed ? 'Navigation__section' : null)}
      >
        <PrimaryNavigation needFixed={needFixed} stay={stay} {...props} />
        {showFilters && (
          <div className={cls('Navigation__filters')}>
            <OfferFilters scrollAfterFilter />
          </div>
        )}
      </div>
    </div>
  );
};

export default withUserContext(withConfiguration(Navigation));
